<template>
    <div class="mt-4">
        <p class="fw-bold primary-color mb-1">{{ title }}</p>
        <p class="fsz-10 third-color mb-3">{{ subtitle }}</p>
        <div :class="[$mq === 'xl' ? 'extra-options-outer-container' : '']">
            <div v-for="(item, index) in serviceOptions" :key="index">
                <div
                    v-if="$mq === 'sm' || $mq === 'md'"
                    :class="[
                        extraOptions[item.option]
                            ? 'extra-options-items-active-container-xs'
                            : 'extra-options-items-inactive-container-xs',
                    ]"
                    @click="changeAdditionalOption(item, index)"
                >
                    <div class="d-flex align-items-center">
                        <img
                            v-if="extraOptions[item.option]"
                            :src="item.activeIconSrc"
                            alt=""
                            width="15"
                            height="17"
                        />
                        <img v-else :src="item.inactiveIconSrc" alt="" width="15" height="17" />
                        <span
                            :class="[
                                extraOptions[item.option]
                                    ? 'fw-bold accent-color fsz-12 ms-3'
                                    : 'fw-bold primary-color fsz-12 ms-3',
                            ]"
                            >{{ item.title }}</span
                        >
                        <price-badge
                            v-if="item.price > 0"
                            :price="item.price"
                            :is-active="extraOptions[item.option]"
                        />
                    </div>
                    <div class="extra-options-items-checkbox-container-xs">
                        <input type="checkbox" class="extra-options-items-checkbox-input-xs" />
                        <div
                            v-if="extraOptions[item.option]"
                            class="extra-options-items-checkbox-tick-xs"
                        >
                            <img src="../assets/tick.svg" alt="" />
                        </div>
                        <div v-else class="extra-options-items-checkbox-box-xs"></div>
                    </div>
                </div>
                <div
                    v-else
                    class="extra-options-container-xl"
                    @mouseenter="hoveredItemId = index"
                    @mouseleave="extraOptions[item.option] ? {} : (hoveredItemId = null)"
                    @click="changeAdditionalOption(item, index)"
                >
                    <div
                        :ref="item.ref"
                        :class="[
                            extraOptions[item.option]
                                ? 'opacity-1'
                                : index === hoveredItemId
                                ? 'opacity-1'
                                : 'extra-options-checkbox-container-xl',
                        ]"
                    >
                        <!-- <input
                            ref="checkboxInput"
                            :checked="extraOptions[item.option]"
                            type="checkbox"
                            class="extra-options-checkbox-input-xl"
                        /> -->

                        <img
                            v-if="extraOptions[item.option]"
                            src="../assets/tick.svg"
                            alt=""
                            width="16"
                            class="extra-options-checkbox-bg-image-xl"
                        />
                        <div v-else class="extra-options-checkbox-bg-color-xl"></div>
                    </div>
                    <div class="w-100 ps-4 d-flex align-items-center">
                        <img v-show="extraOptions[item.option]" :src="item.activeIconSrc" alt="" />
                        <img
                            v-show="!extraOptions[item.option]"
                            :src="item.inactiveIconSrc"
                            alt=""
                        />
                        <span
                            :class="[
                                extraOptions[item.option]
                                    ? 'm-left-2 accent-color fw-bold fsz-14'
                                    : 'm-left-2 primary-color fw-bold fsz-14',
                            ]"
                            >{{ item.title }}</span
                        >
                    </div>
                    <price-badge
                        v-if="item.price > 0"
                        :price="item.price"
                        :is-active="extraOptions[item.option]"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PriceBadge from '../../../components/price-badge/PriceBadge.vue';
export default {
    components: { PriceBadge },
    props: {
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        serviceOptions: {
            type: Array,
            require: true,
            default: () => {
                return [];
            },
        },
        extraOptions: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            hoveredItemId: null,
        };
    },
    methods: {
        // changeAdditionalOption(event, option) {
        //     this.$emit('change-extra-options-event', event, option);
        // },
        changeAdditionalOption(item) {
            this.$emit('change-extra-options-event', this.extraOptions[item.option], item.option);
        },
    },
};
</script>

<style lang="scss" scoped>
.extra-options {
    &-outer-container {
        display: grid;
        grid-template-columns: repeat(3, calc((100% - 32px) / 3));
        column-gap: 16px;
        justify-content: space-between;
    }
    &-container-xl {
        @include centerByFlex;
        border-radius: 8px;
        height: 56px;
        position: relative;
        border: 1px solid #eaeaea;
        margin-bottom: 16px;
        cursor: pointer;
    }
    &-items {
        &-inactive-container-xs {
            border: 1px solid $Gray-Color;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-radius: 8px;
            padding: 0 8px 0 24px;
            margin-bottom: 16px;
            height: 32px;
        }
        &-active-container-xs {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-radius: 8px;
            padding: 0 8px 0 24px;
            margin-bottom: 16px;
            height: 32px;
            background-color: #fff;
            box-shadow: $Black-Shadow;
        }
        &-checkbox {
            &-container-xs {
                width: 16px;
                height: 16px;
                position: relative;
            }
            &-input-xs {
                opacity: 0;
                width: 16px;
                height: 16px;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 5;
            }
            &-box-xs {
                width: 16px;
                height: 16px;
                background-color: $Gray-Color;
                border-radius: 4px;
                position: absolute;
                top: 0;
                left: 0;
            }
            &-tick-xs {
                @include centerByFlex;
                width: 16px;
                height: 16px;
                position: absolute;
                top: 0;
                left: 0;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    &-checkbox {
        &-container-xl {
            opacity: 0;
            transition: all 0.4s;
        }
        &-input-xl {
            width: 16px;
            height: 16px;
            opacity: 0;
            position: absolute;
            z-index: 2;
            cursor: pointer;
            top: 4px;
            right: 4px;
        }
        &-bg {
            &-image-xl {
                position: absolute;
                background-size: contain;
                top: 4px;
                right: 4px;
            }
            &-color-xl {
                width: 16px;
                height: 16px;
                background-color: $Place-Holder-Color;
                border-radius: 4px;
                position: absolute;
                top: 4px;
                right: 4px;
            }
        }
    }
}
</style>
